<template lang="pug">
.confirmTerms
  fieldset.confirmTerms__field(v-for="condition in product.listOfConditions")
    input.confirmTerms__checkbox(
      v-model="listOfAcceptedConditions"
      type='checkbox'
      :key="condition.id"
      :id="`opt-in-${condition.id}`"
      :name="`opt-in-${condition.id}`"
      :value="condition.id"
    )
    label.confirmTerms__label(:for="`opt-in-${condition.id}`" v-html="condition.text")
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      listOfAcceptedConditions: [],
      showModal: false
    }
  },
  watch: {
    listOfAcceptedConditions () {
      const isAllConditionsAccepted = this.product.listOfConditions.some(condition => {
        return condition.required && !this.listOfAcceptedConditions.includes(condition.id)
      })
      this.$emit('acceptedTerms', isAllConditionsAccepted)
    }
  },
  computed: {
    ...mapState(['product'])
  },
  methods: {
    openModal () {
      this.showModal = true
    },
    closeModal () {
      this.showModal = false
    }
  }
}
</script>

<style lang="scss">
.confirmPayment__label,
.confirmTerms__label {
  a,
  span,
  a:link,
  a:visited {
    color: #0a4f85;
  }

  a {
    text-decoration: underline;
  }
}
</style>
<style lang='scss' scoped>
  @import "@/assets/style/_variables";
  .confirmTerms {
    padding-top: 48px;

    &__field:not(:last-child) {
      margin-bottom: 12px;
    }

    &__button {
      cursor: pointer;
      color: #0a4f85;
      text-decoration: underline;
      font-size: 14px;
    }

    &__checkbox {
      position: absolute;
      left: -9999px;

      & + label {
        color: #595959;
        cursor: pointer;
        display: inline-block;
        font-family: $rubik-font-family;
        font-size: 14px;
        line-height: 1.57;
        padding-left: 38px;
        position: relative;

        &:before {
          background: url("~@/assets/icons/check-off.svg") center center no-repeat;
          content: '';
          height: 20px;
          left: 0;
          top: -1px;
          position: absolute;
          width: 20px;
        }
      }

      &:checked + label:before {
        background: url("~@/assets/icons/check-on.svg") center center no-repeat;
      }
    }
  }
</style>
